import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Seo from "./components/Seo";
import Hero from "./components/Hero";
import PropertyGallery from "./components/PropertyGallery";
import AboutArea from "./components/AboutArea";
import TravelGuide from "./components/TravelGuide";
import WhatsIncluded from "./components/WhatsIncluded";
import Travellers from "./components/Travellers";
import TravelConsultancy from "./components/TravelConsultancy";
import NearbyWonders from "./components/NearbyWonders";
import SpyzzzApp from "./components/SpyzzzApp";
import Ventures from "./components/Ventures";
import FAQ from "./components/FAQ";
import PopularSearches from "./components/PopularSearches";
import Contact from "./components/Contact";
import { MetroKochi, Footer } from "./components/MetroKochi";
import MetroKochiPage from "./components/MetroKochiPage";
import {
  About,
  SeoContent,
  ScenicDining,
  Spyzzz,
  Safety,
  Cleanliness,
  EcoFriendly,
  Support,
  Hosts,
} from "./components/Sections";

const Home = () => (
  <div className="font-sans text-neutral-900">
    <Seo
      title="Auracrest Haven | A-Frame Cottages & Luxury Homestay near Sengulam Dam, Anachal, Munnar"
      description="Auracrest Haven — A-frame cottages and luxury homestay near Sengulam Dam in Anachal, Munnar. Private cottage stay with balcony views, family & couple rooms, homemade food and fine dining. ₹1100 per head. Book direct: +91-9388881016."
      keywords="A-frame cottages in Anachal Munnar, Luxury homestay near Sengulam Dam, Private cottage stay with balcony view in Munnar, A-frame cottage Munnar, Home Stay near Anachal, Home Stay near Sengulam Dam, Stay near Anachal, Accommodation near Anachal, Family Room near Anachal, Couple Room near Anachal, Family Room near Munnar, Couple Room near Munnar, Resort near Anachal, Cottage near Anachal, Homestay near Muthuvankudy, Stay near Vellathooval, Homestay near Kunjithanni, Stay near Pallivasal, Stay near Chithirapuram, Stay near Bison Valley, Room Munnar, Stay Munnar, Accommodation Munnar, Resort Munnar, Cottage Munnar, Homestay Munnar"
      canonical="https://www.auracresthaven.com/"
    />
    <Header />
    <Hero />
    <PropertyGallery />
    <About />
    <SeoContent />
    <WhatsIncluded />
    <Travellers />
    <AboutArea />
    <TravelConsultancy />
    <ScenicDining />
    <Spyzzz />
    <SpyzzzApp />
    <NearbyWonders />
    <TravelGuide />
    <Safety />
    <Cleanliness />
    <EcoFriendly />
    <Support />
    <Hosts />
    <Ventures />
    <FAQ />
    <Contact />
    <PopularSearches />
    <MetroKochi />
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/morning_star_metro_home_stay_kochi" element={<MetroKochiPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
